import axios from "axios";
 
const USER_SERVICE_BASE_URL = process.env.REACT_APP_USER_SERVICE_BASE_URL;
 
export const getRoleApi = async (psid: string, appName: string) => {
  try {
    const response = await axios.get(
      `${USER_SERVICE_BASE_URL}/user/${psid}/${appName}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const fetchSuggestionsApi = async (search: string) => {
  if (!search) return;
 
  try {
    const response = await fetch(
      `${USER_SERVICE_BASE_URL}/users/?search=${search}`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
 
export const createUserApi = async (newUser: any) => {
  try {
    const response = await axios.post(`${USER_SERVICE_BASE_URL}/user`, newUser);
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const updateUserRoleApi = async (updateRole: any) => {
  try {
    const response = await axios.put(
      `${USER_SERVICE_BASE_URL}/user/role`,
      updateRole
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
 
export const fetchEmployeesApi = async (appName: string) => {
    try {
      const response = await axios.get(`${USER_SERVICE_BASE_URL}/users/${appName}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };